import { useTheme } from '@/contexts/ThemeContext'

import './Team.css'
import type { Competitor } from '@/services/jsonDataService'

interface TeamProps {
  data?: Competitor
  style?: React.CSSProperties
  isHome?: boolean
  align?: 'left' | 'right'
}

const teamNameFontSize = (length: number) => {
  if (length <= 23) return 0.95
  if (length <= 33) return 0.75
  if (length <= 41) return 0.6
  return 0.5
}

const Team = ({ data, isHome, align = 'left', style }: TeamProps) => {
  const theme = useTheme()

  const teamName = data?.name || 'Team Name'

  if (!data) return
  return (
    <div
      className="team-container"
      style={{
        flexDirection: align === 'left' ? 'row' : 'row-reverse',
        height: `calc(${theme.baseHeight} * 1.333)`,
        padding: `calc(${theme.baseHeight} / 16) calc(${theme.baseHeight} / 5.333)`,
        gap: `calc(${theme.baseHeight} / 3)`,
        ...style,
      }}
    >
      <div
        className="team-color-bar"
        style={{
          backgroundColor: data.color || theme.colors[isHome ? 'homeTeamDefault' : 'awayTeamDefault'],
          width: `calc(${theme.baseHeight} * 0.5)`,
        }}
      />
      <div
        className="team-name"
        style={{
          fontSize: `calc(${theme.baseHeight} * ${teamNameFontSize(teamName.length)})`,
        }}
      >
        {teamName}
      </div>
    </div>
  )
}

export default Team
